module.exports = __webpack_public_path__ + "img/symbol_10.d4345211.png";